
import { Route, Routes, Navigate } from "react-router-dom";
import { useSelector } from "react-redux";
import CabServiceProvider from "../Components/CabServiceProvider/CabServiceProvider";
import ListCabService from "../Components/CabServiceProvider/ListCabService";
import AddCabServiceProvider from "../Components/CabServiceProvider/AddCabServiceProvider";
import SelectCab from "../Components/CabServiceProvider/SelectCab";

const CabServiceProviderRoutes = () => {
  const { admin } = useSelector((state) => state.admin || {});
  const accessCode = admin?.data?.access_code || [];

  const canAdd = Array.isArray(accessCode) && accessCode.includes('add');
  // const canEdit = Array.isArray(accessCode) && accessCode.includes('edit');
  return (
    <Routes>
      <Route path="/cabServiceProvider" element={<ListCabService />}></Route>
      <Route path="/cabServiceProvider/add" element={canAdd ? <AddCabServiceProvider /> : <Navigate to="/cabServiceProvider" replace />}></Route>
      <Route path="/cabServiceProvider/select/:id" element={<SelectCab />}></Route>
    </Routes>
  );
};

export default CabServiceProviderRoutes;
